import { FC } from 'react'

import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { NotificationHeader } from '../../components/NotificationHeader'
import { IntegrationSyncErrorIcon } from './IntegrationSyncErrorIcon'
import { syncErrorTitle } from './integrationSyncErrorMessages'
import { SyncErrorTaskInput } from './types'

export const IntegrationSyncErrorHeader: FC<{ taskId: string }> = ({
  taskId
}) => {
  const { manualTask } = useManualTask({ taskId })
  const input = manualTask?.input as SyncErrorTaskInput | undefined

  if (!input) {
    return null
  }

  return (
    <NotificationHeader
      data-testid="watchtower.notification.integrationSyncError.header"
      fallbackIcon={
        <IntegrationSyncErrorIcon externalService={input.externalService} />
      }
      title={syncErrorTitle(input)}
    />
  )
}
